{
  "familyId": "TOPO-NL-WATER",
  "questions": [
    {
      "id": "TOPO-NL-WATER-001",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welke rivier stroomt door Maastricht?",
      "options": [
        "De Maas",
        "De Rijn",
        "De Waal",
        "De IJssel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Rivieren en steden",
            "content": "De Maas stroomt door het zuiden van Nederland: Maastricht, Venlo, 's-Hertogenbosch. De naam 'Maastricht' komt van 'Maas' + 'tricht' (oversteekplaats).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "river_city_match",
      "variantIndex": 1,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.83,
      "feedback": {
        "explanationText": "De Maas stroomt door Maastricht. De naam 'Maastricht' komt zelfs van 'Maas' + 'tricht' (oversteekplaats over de Maas).",
        "solutionSteps": [
          "Maastricht ligt in Limburg, in het zuiden",
          "De Maas is de rivier van Zuid-Nederland",
          "Ezelsbruggetje: Maas-tricht = oversteekplaats over de Maas"
        ],
        "distractorExplanations": {
          "0": "Goed! De Maas stroomt door Maastricht.",
          "1": "De Rijn stroomt door het midden van Nederland (Arnhem), niet door Maastricht.",
          "2": "De Waal is een tak van de Rijn en stroomt door Nijmegen, niet door Maastricht.",
          "3": "De IJssel stroomt door het oosten (Deventer, Zwolle), niet door Maastricht."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-001-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Rijn"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-001-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Waal"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-001-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De IJssel"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-002",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Waar mondt de Rijn uiteindelijk uit?",
      "options": [
        "In de Noordzee",
        "In het IJsselmeer",
        "In de Waddenzee",
        "In de Middellandse Zee"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "De Rijn",
            "content": "De Rijn begint in Zwitserland, stroomt door Duitsland en Nederland, en mondt uit in de Noordzee bij Rotterdam.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "river_mouth_match",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.8,
      "feedback": {
        "explanationText": "De Rijn begint in de Alpen (Zwitserland), stroomt door Duitsland naar Nederland, en mondt uit in de Noordzee bij Rotterdam.",
        "solutionSteps": [
          "De Rijn begint in de Alpen (Zwitserland)",
          "Hij stroomt door Duitsland naar Nederland",
          "In Nederland splitst hij in Waal, Lek en IJssel",
          "Uiteindelijk mondt alles uit in de Noordzee"
        ],
        "distractorExplanations": {
          "0": "Goed! De Rijn mondt uit in de Noordzee bij Rotterdam.",
          "1": "De IJssel (een tak van de Rijn) stroomt naar het IJsselmeer, maar de Rijn als geheel mondt uit in de Noordzee.",
          "2": "De Waddenzee ligt in het noorden. De Rijn mondt uit in de Noordzee bij Rotterdam.",
          "3": "De Rijn stroomt naar het noorden, niet naar het zuiden. Hij mondt uit in de Noordzee, niet in de Middellandse Zee."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-002-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: In het IJsselmeer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-002-OPT2",
            "optionIndex": 2,
            "label": "De Waddenzee ligt in het noorden"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-002-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: In de Middellandse Zee"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-003",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welke rivier stroomt door Arnhem?",
      "options": [
        "De Rijn",
        "De Maas",
        "De Schelde",
        "De Eems"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "De Rijn door Arnhem",
            "content": "De Rijn komt vanuit Duitsland Nederland binnen bij Arnhem. Bij Arnhem splitst de Rijn zich in de Nederrijn en de IJssel.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "river_city_arnhem",
      "variantIndex": 3,
      "citoDifficulty": 0.2,
      "citoDiscrimination": 0.81,
      "feedback": {
        "explanationText": "De Rijn stroomt door Arnhem. Bij Arnhem splitst de Rijn zich in de Nederrijn (westwaarts) en de IJssel (noordwaarts).",
        "solutionSteps": [
          "De Rijn komt vanuit Duitsland Nederland binnen",
          "Bij Arnhem splitst de Rijn in Nederrijn en IJssel"
        ],
        "distractorExplanations": {
          "0": "Goed! De Rijn stroomt door Arnhem.",
          "1": "De Maas stroomt door Zuid-Nederland (Maastricht, Venlo), niet door Arnhem.",
          "2": "De Schelde stroomt door België en Zeeland, niet door Arnhem.",
          "3": "De Eems stroomt door het noorden (Groningen), niet door Arnhem."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-003-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Maas"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-003-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Schelde"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-003-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Eems"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-004",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Hoe heet het grote meer dat vroeger de Zuiderzee was?",
      "options": [
        "Het IJsselmeer",
        "Het Markermeer",
        "De Waddenzee",
        "Het Veluwemeer"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "IJsselmeer",
            "content": "Het IJsselmeer was vroeger de Zuiderzee. In 1932 werd de Afsluitdijk gebouwd, waardoor de zee een meer werd.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "dutch_waters_ijsselmeer",
      "variantIndex": 4,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Het IJsselmeer was vroeger de Zuiderzee. In 1932 werd de Afsluitdijk gebouwd, waardoor de zee werd afgesloten en een meer werd.",
        "solutionSteps": [
          "De Zuiderzee was een open zee in het midden van Nederland",
          "In 1932 werd de Afsluitdijk gebouwd",
          "Het afgesloten water heet nu het IJsselmeer"
        ],
        "distractorExplanations": {
          "0": "Goed! Het IJsselmeer was vroeger de Zuiderzee.",
          "1": "Het Markermeer is een deel dat later van het IJsselmeer is afgescheiden. Het IJsselmeer is het grote meer.",
          "2": "De Waddenzee ligt ten noorden van de Afsluitdijk en is nog steeds een zee.",
          "3": "Het Veluwemeer is een klein meer bij Flevoland, niet het grote meer."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-004-OPT1",
            "optionIndex": 1,
            "label": "Het IJsselmeer is het grote meer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-004-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Waddenzee"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-004-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Het Veluwemeer"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-005",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welke rivier vormt een deel van de grens tussen Nederland en Duitsland?",
      "options": [
        "De Eems",
        "De Maas",
        "De Waal",
        "De Lek"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Grensrivieren",
            "content": "De Eems stroomt in het noordoosten en vormt bij de Dollard een deel van de grens met Duitsland.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "dutch_border_rivers",
      "variantIndex": 5,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "De Eems stroomt in het noordoosten van Nederland en vormt bij de Dollard een deel van de grens met Duitsland.",
        "solutionSteps": [
          "De grens met Duitsland loopt door het oosten en noordoosten",
          "De Eems stroomt in het noordoosten",
          "Bij de Dollard vormt de Eems de grens"
        ],
        "distractorExplanations": {
          "0": "Goed! De Eems vormt een deel van de grens met Duitsland.",
          "1": "De Maas komt uit België, niet uit Duitsland.",
          "2": "De Waal stroomt dwars door Nederland, niet langs de grens.",
          "3": "De Lek stroomt door het midden van Nederland, niet langs de grens."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-005-OPT1",
            "optionIndex": 1,
            "label": "De Maas komt uit België, niet uit Duitsland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-005-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Waal"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-005-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Lek"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-006",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "De Maas stroomt vanuit Limburg naar het westen. Door welke provincie stroomt hij dan?",
      "options": [
        "Noord-Brabant",
        "Zeeland",
        "Zuid-Holland",
        "Gelderland"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Maas door het zuiden",
            "content": "De Maas stroomt door twee zuidelijke provincies: eerst Limburg, dan Noord-Brabant.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "maas_brabant_limburg",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "De Maas stroomt vanuit Limburg naar het westen door Noord-Brabant, langs 's-Hertogenbosch.",
        "solutionSteps": [
          "De Maas komt Nederland binnen in Limburg",
          "Dan buigt de Maas af naar het westen",
          "Hij stroomt door Noord-Brabant"
        ],
        "distractorExplanations": {
          "0": "Goed! De Maas stroomt vanuit Limburg door Noord-Brabant.",
          "1": "De Westerschelde is de belangrijke waterweg in Zeeland, niet de Maas.",
          "2": "De Maas bereikt uiteindelijk Zuid-Holland, maar eerst stroomt hij door Noord-Brabant.",
          "3": "De Rijn en Waal stromen door Gelderland, niet de Maas."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-006-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Zeeland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-006-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Zuid-Holland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-006-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Gelderland"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-007",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welke rivier stroomt door Nijmegen?",
      "options": [
        "De Waal",
        "De Maas",
        "De Rijn",
        "De IJssel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Waal",
            "content": "De Waal is de breedste tak van de Rijn en stroomt door Nijmegen. De Waal is de drukst bevaren rivier van Europa.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "waal_nijmegen",
      "variantIndex": 7,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De Waal stroomt door Nijmegen. De Waal is de breedste en drukst bevaren tak van de Rijn.",
        "solutionSteps": [
          "De Waal is een tak van de Rijn",
          "De Waal stroomt door Nijmegen",
          "Het is de drukst bevaren rivier van Europa"
        ],
        "distractorExplanations": {
          "0": "Goed! De Waal stroomt door Nijmegen.",
          "1": "De Maas stroomt door Zuid-Nederland (Maastricht, Venlo), niet door Nijmegen.",
          "2": "De Rijn splitst zich bij Arnhem. De tak die door Nijmegen stroomt heet de Waal.",
          "3": "De IJssel stroomt naar het noorden (Deventer, Zwolle), niet door Nijmegen."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-007-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Maas"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-007-OPT2",
            "optionIndex": 2,
            "label": "De Rijn splitst zich bij Arnhem"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-007-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De IJssel"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-008",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Wat is de langste rivier van Nederland?",
      "options": [
        "De Rijn",
        "De Maas",
        "De Waal",
        "De IJssel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Rijn",
            "content": "De Rijn is de langste rivier die door Nederland stroomt. Hij begint in Zwitserland en is meer dan 1.200 km lang.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "longest_river",
      "variantIndex": 8,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De Rijn is de langste rivier die door Nederland stroomt. Hij is meer dan 1.200 km lang en begint in de Alpen.",
        "solutionSteps": [
          "De Rijn is meer dan 1.200 km lang",
          "Hij begint in Zwitserland en stroomt door Duitsland naar Nederland"
        ],
        "distractorExplanations": {
          "0": "Goed! De Rijn is de langste rivier die door Nederland stroomt.",
          "1": "De Maas is ook een lange rivier (ongeveer 925 km), maar de Rijn is langer.",
          "2": "De Waal is een tak van de Rijn, niet een aparte rivier.",
          "3": "De IJssel is ook een tak van de Rijn en veel korter."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-008-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Maas"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-008-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Waal"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-008-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De IJssel"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-009",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welke zee ligt ten noorden van Nederland?",
      "options": [
        "De Noordzee",
        "De Waddenzee",
        "De Middellandse Zee",
        "De Oostzee"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Noordzee",
            "content": "De Noordzee ligt ten noorden en westen van Nederland. De Waddenzee is een ondiepe zee tussen de Waddeneilanden en het vasteland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "noordzee",
      "variantIndex": 9,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "De Noordzee ligt ten noorden en westen van Nederland. Het is een deel van de Atlantische Oceaan.",
        "solutionSteps": [
          "De Noordzee ligt ten noorden en westen van Nederland",
          "De Waddenzee is een kleinere, ondiepe zee bij de Waddeneilanden"
        ],
        "distractorExplanations": {
          "0": "Goed! De Noordzee ligt ten noorden en westen van Nederland.",
          "1": "De Waddenzee is een ondiepe zee tussen de Waddeneilanden en het vasteland, maar de grote zee is de Noordzee.",
          "2": "De Middellandse Zee ligt bij Zuid-Europa, niet bij Nederland.",
          "3": "De Oostzee ligt bij Scandinavië en de Baltische staten, niet bij Nederland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-009-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Waddenzee"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-009-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Middellandse Zee"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-009-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Oostzee"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-010",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welke rivier stroomt door Deventer en Zwolle naar het IJsselmeer?",
      "options": [
        "De IJssel",
        "De Rijn",
        "De Maas",
        "De Waal"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De IJssel",
            "content": "De IJssel is een tak van de Rijn die naar het noorden stroomt, door Deventer en Zwolle, en uitmondt in het IJsselmeer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "ijssel_route",
      "variantIndex": 10,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "De IJssel stroomt door Deventer en Zwolle naar het IJsselmeer. De IJssel is een tak van de Rijn.",
        "solutionSteps": [
          "De IJssel is een tak van de Rijn",
          "Hij stroomt door Deventer en Zwolle",
          "De IJssel mondt uit in het IJsselmeer"
        ],
        "distractorExplanations": {
          "0": "Goed! De IJssel stroomt door Deventer en Zwolle naar het IJsselmeer.",
          "1": "De Rijn splitst zich bij Arnhem. De tak naar het noorden heet de IJssel.",
          "2": "De Maas stroomt door het zuiden, niet door Deventer en Zwolle.",
          "3": "De Waal stroomt naar het westen (door Nijmegen), niet naar het noorden."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-010-OPT1",
            "optionIndex": 1,
            "label": "De Rijn splitst zich bij Arnhem"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-010-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Maas"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-010-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Waal"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-011",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Hoe heet de dijk die het IJsselmeer afsluit van de Waddenzee?",
      "options": [
        "De Afsluitdijk",
        "De Deltawerken",
        "De Houtribdijk",
        "De Oosterscheldekering"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Afsluitdijk",
            "content": "De Afsluitdijk is 32 km lang en sluit het IJsselmeer af van de Waddenzee. Hij werd gebouwd in 1932.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "afsluitdijk",
      "variantIndex": 11,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "De Afsluitdijk is 32 km lang en sluit het IJsselmeer af van de Waddenzee. Hij loopt van Noord-Holland naar Friesland.",
        "solutionSteps": [
          "De Afsluitdijk sluit het IJsselmeer af van de Waddenzee",
          "Hij is 32 km lang",
          "Gebouwd in 1932"
        ],
        "distractorExplanations": {
          "0": "Goed! De Afsluitdijk sluit het IJsselmeer af van de Waddenzee.",
          "1": "De Deltawerken liggen in Zeeland en beschermen tegen de zee, maar sluiten niet het IJsselmeer af.",
          "2": "De Houtribdijk scheidt het IJsselmeer van het Markermeer, niet van de Waddenzee.",
          "3": "De Oosterscheldekering is onderdeel van de Deltawerken in Zeeland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-011-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Deltawerken"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-011-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Houtribdijk"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-011-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Oosterscheldekering"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-012",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Uit welk land komt de Maas Nederland binnen?",
      "options": [
        "België",
        "Duitsland",
        "Frankrijk",
        "Spanje"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De Maas",
            "content": "De Maas begint in Frankrijk, stroomt door België en komt bij Eijsden Nederland binnen (in Zuid-Limburg).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "maas_herkomst",
      "variantIndex": 12,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De Maas komt vanuit België Nederland binnen bij Eijsden in Zuid-Limburg. De Maas begint in Frankrijk en stroomt door België.",
        "solutionSteps": [
          "De Maas begint in Frankrijk",
          "Stroomt door België",
          "Komt bij Eijsden (Zuid-Limburg) Nederland binnen"
        ],
        "distractorExplanations": {
          "0": "Goed! De Maas komt vanuit België Nederland binnen.",
          "1": "De Rijn komt vanuit Duitsland Nederland binnen, maar de Maas komt uit België.",
          "2": "De Maas begint in Frankrijk, maar komt via België Nederland binnen.",
          "3": "Spanje ligt in Zuid-Europa, ver van Nederland. De Maas stroomt door België en komt bij Eijsden Nederland binnen."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-012-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Duitsland"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-012-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Frankrijk"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-012-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Spanje"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-013",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "matching",
      "question": "Koppel elke rivier aan de juiste provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "De Maas",
            "right": "Limburg"
          },
          {
            "left": "De Rijn",
            "right": "Gelderland"
          },
          {
            "left": "De Schelde",
            "right": "Zeeland"
          },
          {
            "left": "De Eems",
            "right": "Groningen"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rivieren en provincies",
            "content": "De Maas stroomt door Limburg, de Rijn door Gelderland, de Schelde door Zeeland, de Eems door Groningen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rivier_provincie_match",
      "variantIndex": 13,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De Maas stroomt door Limburg, de Rijn door Gelderland, de Schelde door Zeeland, de Eems door Groningen.",
        "solutionSteps": [
          "De Maas → Limburg (zuiden)",
          "De Rijn → Gelderland (midden-oosten)",
          "De Schelde → Zeeland (zuidwesten)",
          "De Eems → Groningen (noordoosten)"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-WATER-014",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "matching",
      "question": "Koppel elke rivier aan de stad waar hij doorheen stroomt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "De Maas",
            "right": "Maastricht"
          },
          {
            "left": "De Rijn",
            "right": "Arnhem"
          },
          {
            "left": "De Waal",
            "right": "Nijmegen"
          },
          {
            "left": "De IJssel",
            "right": "Deventer"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rivieren en steden",
            "content": "De Maas stroomt door Maastricht, de Rijn door Arnhem, de Waal door Nijmegen, de IJssel door Deventer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rivier_stad_match",
      "variantIndex": 14,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De Maas stroomt door Maastricht, de Rijn door Arnhem, de Waal door Nijmegen, de IJssel door Deventer.",
        "solutionSteps": [
          "De Maas → Maastricht",
          "De Rijn → Arnhem",
          "De Waal → Nijmegen",
          "De IJssel → Deventer"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-WATER-015",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "In welke drie takken splitst de Rijn zich in Nederland?",
      "options": [
        "Waal, Nederrijn/Lek en IJssel",
        "Maas, Waal en IJssel",
        "Waal, Schelde en IJssel",
        "Nederrijn, Eems en Waal"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Takken van de Rijn",
            "content": "De Rijn splitst zich in Nederland in drie takken: de Waal (de breedste, naar Nijmegen), de Nederrijn/Lek (naar het westen) en de IJssel (naar het noorden).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "rijn_takken",
      "variantIndex": 15,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De Rijn splitst zich in drie takken: de Waal (naar Nijmegen), de Nederrijn/Lek (naar het westen) en de IJssel (naar het noorden, richting IJsselmeer).",
        "solutionSteps": [
          "De Waal: de breedste tak, stroomt door Nijmegen",
          "De Nederrijn/Lek: stroomt naar het westen",
          "De IJssel: stroomt naar het noorden, naar het IJsselmeer"
        ],
        "distractorExplanations": {
          "0": "Goed! De Rijn splitst in Waal, Nederrijn/Lek en IJssel.",
          "1": "De Maas is een aparte rivier, geen tak van de Rijn.",
          "2": "De Schelde is een aparte rivier die door België en Zeeland stroomt.",
          "3": "De Eems is een aparte rivier in het noordoosten, geen tak van de Rijn."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-015-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Maas, Waal en IJssel"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-015-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Waal, Schelde en IJssel"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-015-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Nederrijn, Eems en Waal"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-016",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welke rivier stroomt dwars door Rotterdam?",
      "options": [
        "De Nieuwe Maas",
        "De Rijn",
        "De Waal",
        "De IJssel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Rotterdam en de Nieuwe Maas",
            "content": "De Nieuwe Maas stroomt door Rotterdam. Bekende bruggen zoals de Erasmusbrug en de Willemsbrug liggen over deze rivier.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "nieuwe_maas_rotterdam",
      "variantIndex": 16,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De Nieuwe Maas stroomt dwars door Rotterdam. De bekende Erasmusbrug ligt over deze rivier.",
        "solutionSteps": [
          "Rotterdam ligt in Zuid-Holland",
          "De rivier die door Rotterdam stroomt heet de Nieuwe Maas"
        ],
        "distractorExplanations": {
          "0": "Goed! De Nieuwe Maas stroomt door Rotterdam.",
          "1": "De Rijn splitst zich eerder op. Een deel van dat water stroomt wel door Rotterdam, maar de rivier heet daar de Nieuwe Maas.",
          "2": "De Waal stroomt door Nijmegen, niet door Rotterdam.",
          "3": "De IJssel stroomt naar het noorden, niet door Rotterdam."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-016-OPT1",
            "optionIndex": 1,
            "label": "De Rijn splitst zich eerder op"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-016-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Waal"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-016-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De IJssel"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-017",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Hoe heet het kanaal dat Amsterdam rechtstreeks met de Noordzee verbindt?",
      "options": [
        "Het Noordzeekanaal",
        "Het Amsterdam-Rijnkanaal",
        "De Nieuwe Waterweg",
        "Het Markermeer"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Noordzeekanaal",
            "content": "Het Noordzeekanaal verbindt de haven van Amsterdam met de Noordzee bij IJmuiden.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "noordzeekanaal_amsterdam",
      "variantIndex": 17,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Het Noordzeekanaal verbindt Amsterdam met de Noordzee. Het loopt van het IJ in Amsterdam naar IJmuiden aan de kust.",
        "solutionSteps": [
          "Amsterdam heeft een verbinding met de zee nodig",
          "Dit kanaal loopt naar de Noordzee",
          "Het heet het Noordzeekanaal"
        ],
        "distractorExplanations": {
          "0": "Goed! Het Noordzeekanaal verbindt Amsterdam met de Noordzee.",
          "1": "Het Amsterdam-Rijnkanaal verbindt Amsterdam met de Rijn (richting Utrecht/Duitsland), niet met de zee.",
          "2": "De Nieuwe Waterweg verbindt Rotterdam met de zee, niet Amsterdam.",
          "3": "Het Markermeer is een meer ten oosten van Amsterdam, geen kanaal naar zee."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-017-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Het Amsterdam-Rijnkanaal"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-017-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Nieuwe Waterweg"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-017-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Het Markermeer"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-018",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welke rivier stroomt door Amsterdam en gaf de stad zijn naam?",
      "options": [
        "De Amstel",
        "De Rijn",
        "De Vecht",
        "De Zaan"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Amsterdam en de Amstel",
            "content": "Amsterdam is ontstaan bij een dam in de rivier de Amstel (Amstel-dam). De Amstel stroomt nog steeds door de stad.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "amstel_amsterdam",
      "variantIndex": 18,
      "citoDifficulty": 0.2,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "De Amstel stroomt door Amsterdam. De stad is genoemd naar een dam in deze rivier (Amstel-dam werd Amsterdam).",
        "solutionSteps": [
          "De naam Amsterdam komt van 'Dam in de Amstel'",
          "De rivier heet dus de Amstel"
        ],
        "distractorExplanations": {
          "0": "Goed! De Amstel stroomt door Amsterdam.",
          "1": "De Rijn stroomt niet door Amsterdam.",
          "2": "De Vecht stroomt ten oosten van Amsterdam (bij Weesp en Muiden).",
          "3": "De Zaan stroomt ten noorden van Amsterdam (bij Zaandam)."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-018-OPT1",
            "optionIndex": 1,
            "label": "De Rijn stroomt niet door Amsterdam"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-018-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De Vecht"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-018-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Zaan"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-019",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welke zeearm in Zeeland is de belangrijkste scheepvaartroute naar de haven van Antwerpen?",
      "options": [
        "De Westerschelde",
        "De Oosterschelde",
        "Het Grevelingenmeer",
        "Het Haringvliet"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Westerschelde",
            "content": "De Westerschelde is de zuidelijkste zeearm van Zeeland. Omdat schepen hierdoor naar Antwerpen varen, is deze niet afgesloten met een dam.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "westerschelde_zeeland",
      "variantIndex": 19,
      "citoDifficulty": 0.31,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De Westerschelde is de belangrijkste scheepvaartroute naar Antwerpen. Daarom is deze zeearm open gebleven en niet afgesloten door de Deltawerken.",
        "solutionSteps": [
          "Antwerpen ligt in België, ten zuiden van Zeeland",
          "De zuidelijkste zeearm is de Westerschelde",
          "Hier varen de schepen doorheen"
        ],
        "distractorExplanations": {
          "0": "Goed! De Westerschelde is de route naar Antwerpen.",
          "1": "De Oosterschelde heeft een stormvloedkering en is niet de hoofdroute naar Antwerpen.",
          "2": "Het Grevelingenmeer is afgesloten door een dam.",
          "3": "Het Haringvliet ligt noordelijker, in Zuid-Holland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-019-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Oosterschelde"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-019-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Het Grevelingenmeer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-019-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Het Haringvliet"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-020",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "In welk Zeeuws water ligt de beroemde stormvloedkering van de Deltawerken?",
      "options": [
        "De Oosterschelde",
        "De Westerschelde",
        "Het Hollands Diep",
        "Het Markermeer"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Oosterscheldekering",
            "content": "De Oosterscheldekering is het bekendste onderdeel van de Deltawerken. Hij ligt in de Oosterschelde en kan dicht bij stormvloed.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "oosterschelde_deltawerken",
      "variantIndex": 20,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De beroemde stormvloedkering ligt in de Oosterschelde. Deze kering is normaal open, maar gaat dicht bij gevaarlijk hoog water.",
        "solutionSteps": [
          "De Deltawerken liggen in Zeeland",
          "De bekendste kering is de Oosterscheldekering",
          "Deze ligt in de Oosterschelde"
        ],
        "distractorExplanations": {
          "0": "Goed! De stormvloedkering ligt in de Oosterschelde.",
          "1": "De Westerschelde is open gebleven voor de scheepvaart naar Antwerpen.",
          "2": "Het Hollands Diep ligt meer landinwaarts.",
          "3": "Het Markermeer ligt bij Flevoland, niet in Zeeland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-020-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Westerschelde"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-020-OPT2",
            "optionIndex": 2,
            "label": "Het Hollands Diep ligt meer landinwaarts"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-020-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Het Markermeer"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-021",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welk groot water ligt op de grens van Zuid-Holland en Noord-Brabant, waar veel rivieren samenkomen?",
      "options": [
        "Het Hollands Diep",
        "Het IJsselmeer",
        "De Waddenzee",
        "Het Veluwemeer"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Hollands Diep",
            "content": "Het Hollands Diep is een breed water tussen Zuid-Holland en Noord-Brabant. Hier komen de Maas en de Waal (via de Merwede) samen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "hollands_diep",
      "variantIndex": 21,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Het Hollands Diep is een breed water op de grens van Zuid-Holland en Noord-Brabant. Het bekende knooppunt Moerdijk ligt aan het Hollands Diep.",
        "solutionSteps": [
          "Het water ligt tussen Zuid-Holland en Noord-Brabant",
          "Het heet het Hollands Diep"
        ],
        "distractorExplanations": {
          "0": "Goed! Het Hollands Diep ligt tussen Zuid-Holland en Noord-Brabant.",
          "1": "Het IJsselmeer ligt in het midden/noorden van Nederland.",
          "2": "De Waddenzee ligt in het noorden.",
          "3": "Het Veluwemeer ligt tussen Gelderland en Flevoland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-021-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Het IJsselmeer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-021-OPT2",
            "optionIndex": 2,
            "label": "De Waddenzee ligt in het noorden"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-021-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Het Veluwemeer"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-022",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Hoe heet de gegraven waterweg die Rotterdam met de Noordzee verbindt?",
      "options": [
        "De Nieuwe Waterweg",
        "Het Noordzeekanaal",
        "Het Amsterdam-Rijnkanaal",
        "De Westerschelde"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Nieuwe Waterweg",
            "content": "De Nieuwe Waterweg is gegraven om de haven van Rotterdam een goede verbinding met de Noordzee te geven. Hij loopt langs Hoek van Holland.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "nieuwe_waterweg_rotterdam",
      "variantIndex": 22,
      "citoDifficulty": 0.29,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De Nieuwe Waterweg verbindt Rotterdam met de Noordzee. Hij is in de 19e eeuw gegraven om de haven bereikbaar te houden voor grote schepen.",
        "solutionSteps": [
          "Rotterdam heeft een verbinding met zee nodig",
          "Deze gegraven route heet de Nieuwe Waterweg"
        ],
        "distractorExplanations": {
          "0": "Goed! De Nieuwe Waterweg verbindt Rotterdam met zee.",
          "1": "Het Noordzeekanaal verbindt Amsterdam met zee, niet Rotterdam.",
          "2": "Het Amsterdam-Rijnkanaal verbindt Amsterdam met de Rijn.",
          "3": "De Westerschelde ligt in Zeeland (route naar Antwerpen)."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-022-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Het Noordzeekanaal"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-022-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Het Amsterdam-Rijnkanaal"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-022-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Westerschelde"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-023",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welk groot meer ligt tussen Noord-Holland en Flevoland, ten zuiden van de Houtribdijk?",
      "options": [
        "Het Markermeer",
        "Het IJsselmeer",
        "Het Veluwemeer",
        "Het Grevelingenmeer"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Markermeer",
            "content": "Het Markermeer is het zuidelijke deel van het voormalige IJsselmeer, gescheiden door een dijk (de Houtribdijk tussen Enkhuizen en Lelystad).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "markermeer",
      "variantIndex": 23,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het Markermeer ligt tussen Noord-Holland en Flevoland. Vroeger was het de bedoeling om dit meer ook in te polderen (de Markerwaard), maar dat is niet doorgegaan.",
        "solutionSteps": [
          "Het water ten zuiden van de dijk Enkhuizen-Lelystad heet het Markermeer",
          "Het ligt naast Flevoland en Noord-Holland"
        ],
        "distractorExplanations": {
          "0": "Goed! Het Markermeer ligt tussen Noord-Holland en Flevoland.",
          "1": "Het IJsselmeer ligt ten noorden van het Markermeer.",
          "2": "Het Veluwemeer ligt aan de oostkant van Flevoland (bij Gelderland).",
          "3": "Het Grevelingenmeer ligt in het zuidwesten (Zeeland/Zuid-Holland)."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-023-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Het IJsselmeer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-023-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Het Veluwemeer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-023-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Het Grevelingenmeer"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-024",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welk water ligt tussen de provincie Gelderland (de Veluwe) en Flevoland?",
      "options": [
        "Het Veluwemeer",
        "Het Markermeer",
        "Het IJsselmeer",
        "Het Hollands Diep"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Veluwemeer",
            "content": "Het Veluwemeer is een langwerpig meer (randmeer) dat Flevoland scheidt van de Veluwe in Gelderland.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "veluwemeer",
      "variantIndex": 24,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Het Veluwemeer ligt tussen Gelderland (de Veluwe) en Flevoland. Het is een van de randmeren die zijn overgebleven na de inpoldering van Flevoland.",
        "solutionSteps": [
          "Het meer ligt naast de Veluwe (Gelderland)",
          "Het heet daarom het Veluwemeer"
        ],
        "distractorExplanations": {
          "0": "Goed! Het Veluwemeer ligt tussen Gelderland en Flevoland.",
          "1": "Het Markermeer ligt aan de westkant van Flevoland (bij Noord-Holland).",
          "2": "Het IJsselmeer ligt ten noorden van Flevoland.",
          "3": "Het Hollands Diep ligt in het zuiden van Nederland."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-024-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Het Markermeer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-024-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Het IJsselmeer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-024-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: Het Hollands Diep"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-025",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welke rivier is een voortzetting van de Nederrijn en stroomt langs Vianen en Schoonhoven?",
      "options": [
        "De Lek",
        "De Maas",
        "De IJssel",
        "De Dommel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "De Lek",
            "content": "De Nederrijn verandert bij Wijk bij Duurstede van naam en heet vanaf daar de Lek. De Lek stroomt door Utrecht en Zuid-Holland.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "rivier_lek",
      "variantIndex": 25,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "De Lek is de voortzetting van de Nederrijn. Hij stroomt door de provincies Utrecht en Zuid-Holland, langs steden als Vianen en Schoonhoven.",
        "solutionSteps": [
          "De Rijn splitst in Waal, IJssel en Nederrijn",
          "De Nederrijn gaat verder als de Lek"
        ],
        "distractorExplanations": {
          "0": "Goed! De Lek is de voortzetting van de Nederrijn.",
          "1": "De Maas is een aparte rivier in het zuiden.",
          "2": "De IJssel is de tak van de Rijn die naar het noorden stroomt.",
          "3": "De Dommel is een beek/riviertje in Noord-Brabant."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-025-OPT1",
            "optionIndex": 1,
            "label": "De Maas is een aparte rivier in het zuiden"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-025-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: De IJssel"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-025-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Dommel"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-026",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welke rivier stroomt door Eindhoven en 's-Hertogenbosch in Noord-Brabant?",
      "options": [
        "De Dommel",
        "De Maas",
        "De Vecht",
        "De Amstel"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "De Dommel",
            "content": "De Dommel is een bekende rivier in Noord-Brabant. Hij stroomt dwars door Eindhoven en 's-Hertogenbosch (Den Bosch).",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "dommel_brabant",
      "variantIndex": 26,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "De Dommel stroomt door Noord-Brabant, onder andere door de steden Eindhoven en 's-Hertogenbosch.",
        "solutionSteps": [
          "De rivier stroomt door Noord-Brabant",
          "Het is de Dommel"
        ],
        "distractorExplanations": {
          "0": "Goed! De Dommel stroomt door Noord-Brabant.",
          "1": "De Maas stroomt langs de grens van Noord-Brabant, niet door Eindhoven.",
          "2": "De Vecht stroomt in Overijssel en Utrecht.",
          "3": "De Amstel stroomt in Noord-Holland (Amsterdam)."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-026-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De Maas"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-026-OPT2",
            "optionIndex": 2,
            "label": "De Vecht stroomt in Overijssel en Utrecht"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-026-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Amstel"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-027",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welk groot zoutwatermeer ligt op de grens van Zuid-Holland en Zeeland en is erg populair voor watersport?",
      "options": [
        "Het Grevelingenmeer",
        "Het Markermeer",
        "Het Veluwemeer",
        "De Waddenzee"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Grevelingenmeer",
            "content": "Het Grevelingenmeer is het grootste zoutwatermeer van West-Europa. Het is ontstaan door de Deltawerken en ligt tussen Zuid-Holland en Zeeland.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "grevelingenmeer",
      "variantIndex": 27,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het Grevelingenmeer ligt op de grens van Zuid-Holland en Zeeland. Door de Deltawerken is het afgesloten van de zee, maar het water is nog steeds zout.",
        "solutionSteps": [
          "Het meer ligt in het zuidwesten (Zuid-Holland/Zeeland)",
          "Het is afgesloten door de Deltawerken",
          "Het heet het Grevelingenmeer"
        ],
        "distractorExplanations": {
          "0": "Goed! Het Grevelingenmeer ligt tussen Zuid-Holland en Zeeland.",
          "1": "Het Markermeer ligt bij Noord-Holland en Flevoland.",
          "2": "Het Veluwemeer ligt bij Gelderland en Flevoland.",
          "3": "De Waddenzee ligt in het noorden en is geen afgesloten meer."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-027-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Het Markermeer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-027-OPT2",
            "optionIndex": 2,
            "label": "Verkeerde locatie: Het Veluwemeer"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-027-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Waddenzee"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-028",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "matching",
      "question": "Koppel het water aan de juiste stad of provincie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Nieuwe Maas",
            "right": "Rotterdam"
          },
          {
            "left": "Amstel",
            "right": "Amsterdam"
          },
          {
            "left": "Dommel",
            "right": "Eindhoven"
          },
          {
            "left": "Lek",
            "right": "Zuid-Holland"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wateren en locaties",
            "content": "Nieuwe Maas → Rotterdam, Amstel → Amsterdam, Dommel → Eindhoven, Lek → Zuid-Holland.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "water_locatie_match_1",
      "variantIndex": 28,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "De Nieuwe Maas stroomt door Rotterdam, de Amstel door Amsterdam, de Dommel door Eindhoven en de Lek stroomt door Utrecht en Zuid-Holland.",
        "solutionSteps": [
          "Nieuwe Maas → Rotterdam",
          "Amstel → Amsterdam",
          "Dommel → Eindhoven",
          "Lek → Zuid-Holland"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-WATER-029",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "matching",
      "question": "Koppel het water aan de juiste beschrijving.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          {
            "left": "Noordzeekanaal",
            "right": "Verbindt Amsterdam met zee"
          },
          {
            "left": "Westerschelde",
            "right": "Scheepvaartroute naar Antwerpen"
          },
          {
            "left": "Oosterschelde",
            "right": "Bekend van de stormvloedkering"
          },
          {
            "left": "Markermeer",
            "right": "Ligt ten zuiden van het IJsselmeer"
          }
        ]
      },
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kenmerken van wateren",
            "content": "Noordzeekanaal = Amsterdam naar zee, Westerschelde = route naar Antwerpen, Oosterschelde = stormvloedkering, Markermeer = naast het IJsselmeer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "water_kenmerk_match_1",
      "variantIndex": 29,
      "citoDifficulty": 0.31,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Het Noordzeekanaal verbindt Amsterdam met zee. De Westerschelde is de route naar Antwerpen. De Oosterschelde heeft de bekende stormvloedkering. Het Markermeer ligt ten zuiden van het IJsselmeer.",
        "solutionSteps": [
          "Noordzeekanaal → Verbindt Amsterdam met zee",
          "Westerschelde → Scheepvaartroute naar Antwerpen",
          "Oosterschelde → Bekend van de stormvloedkering",
          "Markermeer → Ligt ten zuiden van het IJsselmeer"
        ]
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": []
      }
    },
    {
      "id": "TOPO-NL-WATER-030",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Welke rivier stroomt door Overijssel langs plaatsen als Ommen en Dalfsen?",
      "options": [
        "De Vecht",
        "De IJssel",
        "De Eems",
        "De Rijn"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "De Overijsselse Vecht",
            "content": "De Vecht (ook wel Overijsselse Vecht genoemd) stroomt vanuit Duitsland door Overijssel en mondt uit in het Zwarte Water bij Zwolle.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "vecht_overijssel",
      "variantIndex": 30,
      "citoDifficulty": 0.37,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "De Vecht stroomt door Overijssel langs plaatsen als Ommen en Dalfsen. (Er is ook een rivier de Vecht in Utrecht, maar deze stroomt in Overijssel).",
        "solutionSteps": [
          "De rivier stroomt door Overijssel",
          "Plaatsen: Ommen en Dalfsen",
          "Dit is de Overijsselse Vecht"
        ],
        "distractorExplanations": {
          "0": "Goed! De Vecht stroomt door Overijssel.",
          "1": "De IJssel stroomt ook door Overijssel, maar langs Deventer en Zwolle, niet Ommen.",
          "2": "De Eems stroomt in Groningen langs de grens.",
          "3": "De Rijn stroomt door Gelderland, Zuid-Holland en Utrecht."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-030-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: De IJssel"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-030-OPT2",
            "optionIndex": 2,
            "label": "De Eems stroomt in Groningen langs de grens"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-030-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De Rijn"
          }
        ]
      }
    },
    {
      "id": "TOPO-NL-WATER-031",
      "familyId": "TOPO-NL-WATER",
      "module": "Topo",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "nederland",
      "subSkill": "topo_wateren",
      "questionType": "multiple_choice",
      "question": "Het water tussen de Waddeneilanden en het vasteland heet de Waddenzee. Wat gebeurt er in de Waddenzee als het eb is?",
      "options": [
        "Grote delen vallen droog en je kunt wadlopen",
        "Het water stroomt over de eilanden",
        "Het water bevriest sneller",
        "De zee wordt een zoetwatermeer"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "map",
          "data": {
            "title": "Kaart van nederland",
            "region": "nederland",
            "highlight": "topo_wateren"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Waddenzee bij eb",
            "content": "De Waddenzee is erg ondiep. Bij eb (laagwater) vallen grote zandplaten droog. Dan kun je wadlopen.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "waddenzee_eb",
      "variantIndex": 31,
      "citoDifficulty": 0.21,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Bij eb (laagwater) stroomt het water weg naar de Noordzee en vallen grote zandplaten in de Waddenzee droog. Dit maakt wadlopen mogelijk.",
        "solutionSteps": [
          "De Waddenzee is erg ondiep",
          "Eb betekent laagwater",
          "Het water zakt en de zandbodem (het wad) komt droog te liggen"
        ],
        "distractorExplanations": {
          "0": "Goed! Bij eb vallen grote delen van de Waddenzee droog.",
          "1": "Dat zou een overstroming zijn, dat gebeurt niet bij eb.",
          "2": "Eb heeft niets te maken met bevriezen.",
          "3": "De Waddenzee blijft zout water, het wordt geen zoetwatermeer."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-031-OPT1",
            "optionIndex": 1,
            "label": "Verkeerde locatie: Het water stroomt over de eilan"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-031-OPT2",
            "optionIndex": 2,
            "label": "Eb heeft niets te maken met bevriezen"
          },
          {
            "id": "TOPO-MISCONCEPT-TOPO-NL-WATER-031-OPT3",
            "optionIndex": 3,
            "label": "Verkeerde locatie: De zee wordt een zoetwatermeer"
          }
        ]
      }
    }
  ]
}